export const BASE_URL = 'https://taxsys.zydl-tec.cn'
export const DEV_BASE_URL = 'https://taxsys.zydl-tec.cn'

export const LOGIN = '/sys/login'
export const PASS_LOGIN = '/sys/admin/login'; // 密码登录
export const LOGIN_INFO = '/sys/admin/info'

export const EDIT_ADMIN_PASS = '/sys/admin/editpass' //管理员修改密码

export const ORDER_LIST = '/sys/order/list'
export const ORDER_COUNT = '/sys/order/ordercount'

export const FAC_LIST = '/sys/factory/page'
export const FAC_LIST_NP = '/sys/factory/list'
export const FAC_ADD = '/sys/factory/add'
export const FAC_EDIT = '/sys/factory/update'
export const FAC_DEL = '/sys/factory/del'

export const FAC_ADMIN_LIST = '/sys/facadmin/page'
export const FAC_ADMIN_LIST_NP = '/sys/facadmin/list'
export const FAC_ADMIN_ADD = '/sys/facadmin/add'
export const FAC_ADMIN_EDIT = '/sys/facadmin/update'
export const FAC_ADMIN_DEL = '/sys/facadmin/del'
export const FAC_ADMIN_EDIT_PASS = '/sys/facadmin/resetpass'


export const HOME_FAC_COUNT = '/sys/order/report'
export const HOME_BO_CHART = '/sys/order/chart'

export const KA_LIST_NP = '/sys/kakou/list' //卡口列表
export const KA_LIST = '/sys/kakou/page'
export const KA_ADD = '/sys/kakou/add'
export const KA_EDIT = '/sys/kakou/update'
export const KA_DEL = '/sys/kakou/del'

export const KA_ADMIN_LIST = '/sys/kakouadmin/page'
export const KA_ADMIN_ADD = '/sys/kakouadmin/add'
export const KA_ADMIN_EDIT = '/sys/kakouadmin/update'
export const KA_ADMIN_DEL = '/sys/kakouadmin/del'
export const KA_ADMIN_EDIT_PASS = '/sys/kakouadmin/resetpass'
export const KA_ADMIN_LIST_NP = '/sys/kakouadmin/list'

//验证码
export const SMS_VERIFY = '/sys/mobile/sendMessage'
export const SMS_VERIFY_CHANGE_MOBILE = '/sys/mobile/updateSend'

// 更换手机号
export const CHANGE_MOBILE = '/sys/admin/updatemobile'
